/* unplugin-vue-components disabled */import { render } from "./ProgramList.vue?vue&type=template&id=789c75b2&scoped=true"
import script from "./ProgramList.vue?vue&type=script&lang=js"
export * from "./ProgramList.vue?vue&type=script&lang=js"

import "./ProgramList.vue?vue&type=style&index=0&id=789c75b2&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789c75b2"]])

export default __exports__